module.exports = __webpack_public_path__ + "img/components (13).2f9fa3e4.png";